import React from 'react';
import { motion } from 'framer-motion';
import { scrollToCompra } from '../../utils/scroll';
interface ScrollButtonProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function ScrollButton({
  children,
  className = '',
  variant = 'primary',
  fullWidth = false
}: ScrollButtonProps) {
  const baseStyles = 'relative overflow-hidden font-bold rounded-full shadow-lg transition-all duration-300 flex items-center justify-center text-center';
  const variants = {
    primary: 'bg-[#22C55E] text-white hover:bg-[#16a34a] hover:shadow-xl hover:-translate-y-1',
    secondary: 'bg-[#C4A7E7] text-[#111111] hover:bg-[#a78bcc] hover:shadow-xl hover:-translate-y-1'
  };
  const widthClass = fullWidth ? 'w-full px-6 py-4 text-lg md:text-xl' : 'px-8 py-4 text-lg';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={scrollToCompra} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} data-id="element-271">
      <span className="relative z-10 flex items-center justify-center gap-2 w-full" data-id="element-272">
        {children}
      </span>
    </motion.button>;
}